// language=GraphQL
export const ALL_EXTENSION_ACCOMMODATIONS_QUERY = `query Query {
  extensionAccommodations: ratioExtensionAccommodations {
    id
    ratioPackageNo
    name
    label
    info
    extensionAccommodationServiceNo
  }
}`

// language=GraphQL
export const SINGLE_EXTENSION_ACCOMMODATION_QUERY = `query Query($id: ID!) {
  extensionAccommodation: ratioExtensionAccommodation(id: $id) {
    id
    ratioPackageNo
    name
    label
    info
    extensionAccommodationServiceNo
  }
}`

// language=GraphQL
export const CREATE_EXTENSION_ACCOMMODATION_MUTATION = `
  mutation Mutation($input: CreateRatioExtensionAccommodationInput) {
    extensionAccommodation: createRatioExtensionAccommodation(input: $input) {
      id
      ratioPackageNo
      name
      label
      info
      extensionAccommodationServiceNo
    }
  }`

// language=GraphQL
export const UPDATE_EXTENSION_ACCOMMODATION_MUTATION = `
  mutation Mutation($input: UpdateRatioExtensionAccommodationInput) {
    extensionAccommodation: updateRatioExtensionAccommodation(input: $input) {
      id
      ratioPackageNo
      name
      label
      info
      extensionAccommodationServiceNo
    }
  }`

// language=GraphQL
export const DELETE_EXTENSION_ACCOMMODATION_MUTATION = `
  mutation Mutation($input: DeleteRatioExtensionAccommodationInput) {
    deleteRatioExtensionAccommodation(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_EXTENSION_ACCOMMODATION_MUTATION = `
  mutation Mutation($input: DeleteRatioExtensionAccommodationInput) {
    forceDeleteRatioExtensionAccommodation(input: $input) {
      success
    }
  }`
// language=GraphQL
export const EXTENSION_ACCOMMODATIONS_DEPENDENTS_QUERY = `query Query($id: ID!, $withRatioAccommodationExtensionMapItems: Boolean = false, $withRatioTravels: Boolean = false) {
  groupedDependents: ratioExtensionAccommodationDependents(id: $id) {
    ratioAccommodationExtensionMapItems @include(if: $withRatioAccommodationExtensionMapItems) {
      id
    }
    ratioTravels @include(if: $withRatioTravels) {
      id
      catalogCode
      travelCode
      destination
      name
      transportType
      transportTypeLabel
      importDateTime
      importStatus    }
  }
}`
